module.exports = __webpack_public_path__ + "static/img/halfdome.6577350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/halfdome.jpg
// module id = /gO/
// module chunks = 1